import classNames from 'classnames';
import React from 'react';
// Disabling the rule due to the linter not being able to resolve dynamic class name use in this component
// eslint-disable-next-line css-modules/no-unused-class
import styles from './typography.module.scss';

type TypographyTag =
  | 'a'
  | 'div'
  | 'span'
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'p'
  | 'small'
  | 'label';

export type TypographyStyle =
  | 'bodyLarge'
  | 'bodyLargeBold'
  | 'bodyMedium'
  | 'bodyMediumBold'
  | 'bodySmall'
  | 'bodySmallBold'
  | 'cta'
  | 'date'
  | 'displayLarge'
  | 'displayMedium'
  | 'distance'
  | 'headingLarge'
  | 'headingMedium'
  | 'headingSmall'
  | 'labelLarge'
  | 'labelMedium'
  | 'labelSmall'
  | 'menuItem'
  | 'priceLarge'
  | 'priceMedium'
  | 'priceSmall'
  | 'splash'
  | 'splashOffer'
  | 'subHeading';

export interface TypographyProps extends React.HTMLAttributes<HTMLElement> {
  /** The text to show */
  children?: React.ReactNode;
  /** The id of the element the label is for */
  htmlFor?: string;
  /** The html tag to be used for the typography */
  tag?: TypographyTag;
  /** The typography styling to be used */
  tagStyle?: TypographyStyle;
  /** The text to show */
  text?: string;
}

const Typography = ({
  children,
  className,
  tag = 'span',
  tagStyle = 'bodyMedium',
  text,
  ...rest
}: TypographyProps) => {
  const Tag = tag;

  if (text) {
    return (
      <Tag
        {...rest}
        className={classNames(styles.component, styles[tagStyle], className)}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    );
  }

  return (
    <Tag
      {...rest}
      className={classNames(styles.component, styles[tagStyle], className)}
    >
      {children}
    </Tag>
  );
};

Typography.displayName = 'Typography';

export default Typography;
